import PasswordModal, { setCheckPasswordFunction } from './PasswordModal';

export { setCheckPasswordFunction };
export default PasswordModal;